<script setup lang="ts">
import { type Component, computed } from 'vue';

import NarrowableDashboardReport from '@/components/VisionAi/chat-panel-components/widgets/NarrowableDashboardReport.vue';
import CannedPromptButtonWidget from '@/components/VisionAi/widgets/CannedPromptButtonWidget.vue';
import CustomerSupportWidget from '@/components/VisionAi/widgets/CustomerSupportWidget.vue';
import LibraryMediaWidget from '@/components/VisionAi/widgets/LibraryMediaWidget.vue';
import MetricCardWidget from '@/components/VisionAi/widgets/MetricCardWidget.vue';
import RedirectButtonWidget from '@/components/VisionAi/widgets/RedirectButtonWidget.vue';
import type {
  VisionAiWidgetClickPayload,
  VisionWidget,
  WidgetType,
} from '@/components/VisionAi/widgets/visionWidget.types';

const { widgets = [], narrowMode = false } = defineProps<{
  widgets?: VisionWidget[];
  narrowMode?: boolean;
}>();

const emit = defineEmits<{
  expand: [];
  widgetInteraction: [payload: VisionAiWidgetClickPayload];
}>();

const WIDGET_COMPONENT_MAP: Record<WidgetType, Component> = {
  canned_prompt: CannedPromptButtonWidget,
  customer_support: CustomerSupportWidget,
  legacy_dashboards_report: NarrowableDashboardReport,
  library_media: LibraryMediaWidget,
  library_media_group: LibraryMediaWidget,
  metric_card: MetricCardWidget,
  redirect_button: RedirectButtonWidget,
};

const resolvedWidgets = computed(() =>
  widgets.map((widget, index) => ({
    component: WIDGET_COMPONENT_MAP[widget.type],
    data: widget.data,
    key: `unified-widget-${index}`,
  })),
);
</script>

<template>
  <component
    :is="entry.component"
    v-for="entry in resolvedWidgets"
    :key="entry.key"
    :widget-data="entry.data"
    :narrow-mode="narrowMode"
    @expand="emit('expand')"
    @on-widget-click="emit('widgetInteraction', $event)"
  />
</template>
